/**
 * Gestion de fichier sprite SVG
 * Et implémentation de SVG via classes CSS
 */

// Import des svg dans le lepreuchaun (sprite)
requireAll(require.context('../icon/', true, /\.svg$/));

jQuery(document).ready(function () {

    /*
     * Patterns
     */

    /*
    let h2 = jQuery('h2:not(.h1):not(.h3):not(.h4):not(.h5):not(.h6), .h2');
    h2.each(function () {
        let element = jQuery(this);
        let content = element.html();
        content = content.split(' ');

        content[content.length - 1] = '<span class="last-word">' + content[content.length - 1] + '</span>';
        jQuery(this).html(content.join(' '));
    });
    */

    //let bgLine = jQuery('.bg-line').addClass('use-svg use-pattern use-pattern-line');
    /* END */

    let $cardButton = jQuery('.card-button a').addClass('button-link');
    let $buttons = jQuery('.frm_button_submit,.button:not(.use-svg):not(.button-no-svg)').addClass('use-svg use-icon use-icon-arrow-button svg-margin-small flex-row-reverse');
    //let $buttons_secondary = jQuery('.button.button-secondary').addClass('use-svg use-icon use-icon-arrow-button-secondary svg-margin-small flex-row-reverse');
    let $links = jQuery('.button-link').addClass('use-svg use-icon use-icon-arrow-link svg-margin-small flex-row-reverse');
    let $submenus = jQuery('.has-mega-menu > a').addClass('use-svg use-icon use-icon-has-mega-menu svg-margin flex-row-reverse');


    // EDITOR
    let $h1_titles = jQuery('h1.editor-icon-title:not(.use-svg),.h1.editor-icon-title:not(.use-svg)').addClass('use-svg use-icon use-icon-title-h1 on-top');
    let $h2_titles = jQuery('h2.editor-icon-title:not(.use-svg),.h2.editor-icon-title:not(.use-svg)').addClass('use-svg use-icon use-icon-title on-top');
    let $editorDuree = jQuery('.editor-icon-duree:not(.use-svg)').addClass('use-svg use-icon use-icon-duree svg-margin');
    let $editorTel = jQuery('.editor-icon-tel:not(.use-svg)').addClass('use-svg use-icon use-icon-phone svg-margin');
    let $editorEmail = jQuery('.editor-icon-email:not(.use-svg)').addClass('use-svg use-icon use-icon-email svg-margin');
    let $editorDownload = jQuery('.editor-icon-download:not(.use-svg)').addClass('use-svg use-icon use-icon-download svg-margin');
    let $editorWay = jQuery('.editor-icon-way:not(.use-svg)').addClass('use-svg use-icon use-icon-way svg-margin-small flex-row-reverse button');

    //let $toggleBlocks = jQuery('.toggle-block');
    //$toggleBlocks.find('> .toggle-block__btn').addClass('use-svg use-icon use-icon-chevron-down on-right flex-row-reverse');

    //initColorsAndPAtterns();
    setSvg();

    jQuery('.slick').on('init', function () {
        setSvg();
    });
});

jQuery(document).ajaxComplete(function () {
    setSvg();
});

jQuery(document).on('frmPageChanged', function (event, form, response) {
    setSvg();
});

// Autoloader JS
function requireAll(r) {
    r.keys().forEach(r);
}

function initColorsAndPAtterns(){
    let $vc_rows = jQuery("#page-content > .container-content > .wpb-content-wrapper  > .vc_row[data-vc-full-width='true']");
    if( $vc_rows.length < 1 )
        $vc_rows = jQuery("#page-content > div[class*=bg-color-]:not(.related-posts)");

    let $related = jQuery('.related-posts');
    let $last_vc_row = $vc_rows.last();


    let $colors = [
        'default',
        '6',
    ];

    // enchainement des fonds de couleur et des patterns
    let $max = $colors.length;
    let $current = 1;
    $vc_rows.each(function( index ){
        let $element = jQuery(this);
        let $prevElement = $element.prevAll('.vc_row:not(.vc_clearfix)').first();

        if( index == 0  ){

        }
        else if( !$element.is('[class*=bg-color-]') ){
            if( $colors[ $current ] != 'default' ){
                $element.addClass('bg-color-' + $colors[ $current ] );
            }

            $current++;
            if($current >= $max)
                $current = 0;
        }

        if ($prevElement.length && $prevElement.attr('class')) {

            let currentClasses = $element.attr('class').split(' ');
            let prevClasses = $prevElement.attr('class').split(' ');

            let currentBackgroundClass = currentClasses.find(c => c.includes('bg-color-'));
            let prevBackgroundClass = prevClasses.find(c => c.includes('bg-color-'));

            // Appliquer le style si les deux éléments ont une classe de fond correspondante
            if (currentBackgroundClass && prevBackgroundClass && currentBackgroundClass === prevBackgroundClass) {
                $element.css('padding-top', '0');
            }
        }
    });
}

// Ajout de SVG par détection de classes CSS : use-icon use-icon-[NAME]
function setSvg() {
    let use_svg = jQuery('.use-svg:not(.is-loaded)');
    if (use_svg.length) {
        use_svg.each(function () {
            let elt = jQuery(this);
            let classList = jQuery(this).attr('class').split(/\s+/);
            jQuery.each(classList, function (index, item) {
                if (item.includes('use-icon-')) {
                    jQuery(elt).addClass('is-loaded');
                    let svg = item.replace('use-', '');
                    elt.prepend('<svg class="sprite-icon sprite-' + svg + '"><use xlink:href="#' + svg + '"></use></svg>');
                }

                if (item.includes('use-pattern-')) {
                    jQuery(elt).addClass('is-loaded');
                    let svg = item.replace('use-', '');
                    elt.prepend('<svg class="sprite-pattern sprite-' + svg + '"><use xlink:href="#' + svg + '"></use></svg>');
                }
            });
        });
    }
}
